import {
  AuthenticationContext,
  AuthenticationOptions,
  inject,
  UserContext,
} from "@myob/ldal";
import Config from "config";
import { inIframe } from "../helpers/tools";

let authenticationAdapter: AuthenticationAdapter;

export const LOGIN_ERROR_MESSAGE = "login not work";
export class AuthenticationAdapter {
  authenticationContext: AuthenticationContext;

  constructor(options: AuthenticationOptions) {
    this.authenticationContext = inject(options);
    this.authenticationContext.handleOAuth2Callback();
  }

  getUser(): UserContext | undefined {
    return this.authenticationContext.getUser();
  }

  login(): void {
    if (!this.isLoggedIn() && !inIframe()) {
      this.authenticationContext.logIn();
      return;
    }
  }

  logout(): void {
    this.authenticationContext.logOut();
  }

  async acquireToken(): Promise<string> {
    return new Promise((resolve, reject) => {
      this.authenticationContext.acquireToken(
        Config.AUTHENTICATION_BFF_CLIENT_ID,
        (token: string, error: boolean) => {
          if (error) {
            this.login();
            reject(LOGIN_ERROR_MESSAGE);
          } else {
            resolve(token);
          }
        }
      );
    });
  }

  isLoggedIn(): boolean {
    return (
      this.authenticationContext.getToken(
        Config.AUTHENTICATION_BFF_CLIENT_ID
      ) !== null
    );
  }
}

export default function index(): AuthenticationAdapter {
  if (authenticationAdapter == null) {
    authenticationAdapter = new AuthenticationAdapter({
      authority: Config.AUTHENTICATION_AUTHORITY,
      clientId: Config.AUTHENTICATION_WEB_CLIENT_ID,
      loginResource: Config.AUTHENTICATION_BFF_CLIENT_ID,
      storageLocation: "sessionStorage",
      redirectUri: window.location.origin,
      postLogoutRedirectUri: window.location.origin,
    });
  }
  return authenticationAdapter;
}
